<template>
  <div class="cabinet-outfit-container">
    <div class="jc-page-header">
      <h1>
        <a href="javascript:void(0)"
           @click="goBack">
          <i class="el-icon-arrow-left"></i>
        </a>{{$t('ticket.submissionWork')}}
      </h1>
    </div>
    <div class="jc-page-content">
      <!-- 表单 -->
      <el-form :model="ruleForm"
               ref="ruleForm"
               :rules="rules"
               label-width="120px"
               class="cabinet-outfit-form">
        <el-form-item :label="$t('ticket.workType') + '：'"
                      prop="ticketTypeName">
          <span>{{ruleForm.ticketTypeName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <a :href="downloadUrl">{{downLoadTip}}</a>
        </el-form-item>

        <el-form-item :label="$t('ticket.workName') + '：'"
                      prop="ticketTemplateId"
                      required
                      :show-message="false">
          <el-radio-group v-model="ruleForm.ticketTemplateId"
                          @change="handleChange">
            <el-radio size="small"
                      :label="item.ticketTemplateId"
                      v-for="item in ticketTemplates"
                      :key="item.ticketTemplateId">{{item.ticketTemplateName}}</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- <el-form-item :label="$t('ticket.userPin') + '：'"
                      prop="pin">
          <span>{{ruleForm.pin}}</span>
        </el-form-item> -->

        <!-- <el-form-item :label="$t('text.fullName') + '：'" prop="name">
          <span>{{ruleForm.name != ''?ruleForm.name:'--'}}</span>
        </el-form-item> -->

        <el-form-item :label="$t('text.tel') + '：'"
                      prop="phone">
          <span>{{ruleForm.phone | isStrEmpty}}</span>
        </el-form-item>

        <el-form-item :label="$t('text.email') + '：'"
                      prop="email">
          <span v-if="userInfo.email != '' && userInfo.email != null">{{userInfo.email}}</span>
          <el-input size="small"
                    v-else
                    v-model="ruleForm.email"
                    :maxlength="256"
                    :minlength="0"
                    :placeholder="$t('serviceSupport.email')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('merge.roomName') + '：'"
                      prop="idcNo1"
                      required
                      :show-message="false">
          <el-select size="small"
                     v-model="ruleForm.idcNo1"
                     :placeholder="$t('placeholder.roomName')"
                     @change="selectRegion">
            <el-option v-for="regin in fliter_region"
                       :value="regin.region"
                       :key="regin.idcId">{{regin.region}}</el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('ticket.contractEditNum') + '：'"
                      prop="contractId"
                      required
                      :show-message="false">
          <el-select size="small"
                     v-model="ruleForm.contractId"
                     :placeholder="$t('placeholder.chooseContract')">
            <el-option v-for="item in contractsList"
                       :label="item.label"
                       :value="item.id"
                       :key="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('ticket.remark') + '：'"
                      class="textarea-note">
          <el-input size="small"
                    v-model="ruleForm.remarks"
                    type="textarea"
                    :maxlength="256"
                    :minlength="0"
                    :placeholder="$t('placeholder.chooseRemark')"></el-input>
          <div style="color: rgb(185, 183, 183);width: 388px !important;text-align: right;">{{$t('merge.wordCount',[ruleForm.remarks.length])}}</div>
        </el-form-item>

        <el-form-item :label="$t('text.enclosure')+ '：'"
                      prop="attach"
                      required
                      :show-message="false">
          <el-upload class="upload-demo"
                     :limit="1"
                     name="upFile"
                     :before-upload="beforeAvatarUpload"
                     action="/ccs-api/api/ticket/importToOssByName"
                     :on-exceed="handleExceed"
                     :on-change="handleUploadChange"
                     :on-success="success"
                     :on-error="error"
                     :data="formData"
                     :on-remove="removeFile">
            <el-button size="small"
                       type="primary">{{$t('ticket.upLoadWorkTemplate')}}</el-button>
            <span style="color:red;padding-left: 10px;"
                  v-if="hasEnclosure">{{$t('ticket.accessoriesNotEmpty')}}</span>
            <div slot="tip"
                 class="jc-upload__tip">{{$t('speechcraft.submitWorkUp')}}</div>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <el-button size="small"
                     @click="cancelForm()">{{$t('text.cancel')}}</el-button>
          <el-button size="small"
                     type="primary"
                     @click="submitForm('ruleForm')"
                     :disabled="disabled">{{$t('text.submission')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

export default {
  components: {},

  name: 'CabinetOutfit',

  data () {
    const emailValidator = (rule, value, callback) => {
      const regexPhone = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (value !== '') {
        if (!regexPhone.test(value)) {
          return callback(new Error(this.$t('equipmentMoveIn.placeholder.correctEmail')));
        }
        callback();
      } else {
        return callback(new Error(this.$t('faultReport.placeholderDefault', [this.$t('text.email')])));
      }
    };
    return {
      ticketTypeId: null,
      ticketTemplates: null,
      downloadUrl: '',
      userInfo: {
        email: '',
      },
      fliter_region: [],
      contractsList: [],
      formData: {
        fileName: ''
      },
      downLoadTip: this.$t('ticket.applyCabinetDownload'),
      hasEnclosure: false,
      disabled: false,
      ruleForm: {
        ticketTemplateId: null,
        ticketTemplateCode: '',
        idcId: 0,
        idcNo: '',
        idcNo1: '',
        idcLine: null,
        contractId: 0,
        contractId: '',
        remarks: '',
        ticketTypeName: null,
        pin: null,
        // name: null,
        phone: null,
        email: null,
        attach: []
      },
      rules: {
        ticketTemplateId: [{ required: true }],
        idcNo1: [{ required: true }],
        contractId: [{ required: true }],
        email: [{
          required: true,
          trigger: 'change',
          message: this.$t('faultReport.placeholderDefault', [this.$t('text.email')])
        },
        { validator: emailValidator, trigger: 'change' }],
      }
    };
  },

  created () {
    this.ticketTypeId = this.$route.params.id;
    this.getTicketTemplates();
    this.getUserInfo();
    this.getRegion();
    this.getContracts();
  },

  mounted () { },

  watch: {},

  filters: {
    isStrEmpty (value) {
      if (value != '') return value;
      return '--';
    }
  },

  computed: {},

  methods: {
    getTicketTemplates () {
      const self = this;
      const params = {
        ticketTypeId: this.ticketTypeId
      };
      this.$api.getTicketTemplates(params).then((temp) => {
        // var temp = JSON.parse(res);
        if (temp.errno === 10000 && temp.errmsg === 'OK') {
          if (
            temp.data
            && temp.data.ticketTemplates
            && temp.data.ticketTemplates.length > 0
            && temp.data.ticketTemplates[0] != null
          ) {
            self.ticketTemplates = temp.data.ticketTemplates;
            self.downloadUrl = self.ticketTemplates[0].attachTemplatePath;
            self.ruleForm.ticketTemplateId = self.ticketTemplates[0].ticketTemplateId;
            self.ruleForm.ticketTypeName = self.ticketTemplates[0].ticketTypeName;
            self.ruleForm.ticketTemplateCode = self.ticketTemplates[0].ticketTemplateCode;
          } else {
            self.ticketTemplates = [];
          }
        } else {
          this.$message.error(temp.errmsg);
        }
      });
    },

    handleChange (id) {
      this.ticketTemplates.forEach((item) => {
        if (id == item.ticketTemplateId) {
          this.ruleForm.ticketTypeName = item.ticketTypeName;
          this.downloadUrl = item.attachTemplatePath;
        }
      });
    },

    getUserInfo () {
      const self = this;
      this.$api.getUserInfo({}).then((temp) => {
        // var temp = JSON.parse(res);
        if (temp.errno === 10000 && temp.errmsg === 'OK') {
          if (temp.data && temp.data.ucDetail) {
            self.userInfo = temp.data.ucDetail;
            self.setUserInfo();
          }
        } else {
          this.$message.error(temp.errmsg);
        }
      });
    },

    setUserInfo () {
      this.ruleForm.pin = this.userInfo.pin;
      this.ruleForm.name = this.userInfo.name;
      this.ruleForm.phone = this.userInfo.phone;
      if (this.userInfo.email !== '' && this.userInfo.email) {
        this.ruleForm.email = this.userInfo.email;
      }
    },

    submitForm (formName) {
      if (this.ruleForm.attach.length > 0) {
        this.hasEnclosure = false;
      } else {
        this.hasEnclosure = true;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disabled = true;
          this.submitWorksheet();
        } else {
          return false;
        }
      });
    },

    submitWorksheet () {
      let params = Object.assign({}, this.ruleForm);
      console.log(this.ruleForm);
      delete params.ticketTypeName;
      delete params.pin;
      delete params.name;
      // delete params.phone;
      // delete params.email;
      delete params.idcNo1;
      params = JSON.parse(JSON.stringify(params));
      console.log(params);
      params.idcLine = 1;
      this.$api.submitContracts(params).then((temp) => {
        setTimeout(() => { this.disabled = false; }, 1000);
        // var temp = JSON.parse(res);
        if (temp.errno === 10000 && temp.errmsg === 'OK') {
          if (temp.data) {
            this.$router.push({ path: '/myworksheet/list' });
          }
        }
      });
    },

    success (response, file, fileList) {
      this.$message.success(this.$t('ticket.handleSuccess'));
      const { errmsg, data } = response;
      this.ruleForm.attach = [];
      this.hasEnclosure = false;
      this.ruleForm.attach.push({
        attachName: data.fileName,
        attachPath: data.ossUrl
      });
    },

    error () {
      this.$message.error(this.$t('merge.uploadError'));
    },

    removeFile () {
      this.ruleForm.attach = [];
    },

    selectRegion (item) {
      const self = this;
      this.fliter_region.forEach((cur) => {
        if (cur.region == item) {
          self.ruleForm.idcId = cur.idcId;
          self.ruleForm.idcNo = cur.idcNo;
        }
      });
    },

    getRegion () {
      const self = this;
      this.$api.getRegions({ all: 1, idcLine: this.GLOBAL.IDCLINE }).then((temp) => {
        // var temp = JSON.parse(res);
        if (temp.errno === 10000 && temp.errmsg === 'OK') {
          if (temp.data && temp.data.idcs.length > 0 && temp.data.idcs[0] != null) {
            const data = temp.data.idcs;
            self.regionFormat(data);
          } else {
            self.fliter_region = [];
          }
        }
      });
    },

    getContracts () {
      const self = this;
      const params = { all: 1, includeTerminatedContract: 'no' };
      this.$api.getContracts(params).then((temp) => {
        // var temp = JSON.parse(res);
        if (temp.errno === 10000 && temp.errmsg === 'OK') {
          if (temp.data && temp.data.contracts.length > 0 && temp.data.contracts[0] != null
          ) {
            self.contractsList = temp.data.contracts;
            this.contractsList.forEach((item) => {
              item.label = `${item.contractNo}-${item.contractName}(${item.startTime}-${item.endTime})`;
            });
          } else {
            self.contractsList = [];
          }
        }
      });
    },

    regionFormat (data) {
      this.fliter_region = [];
      for (let i = 0; i < data.length; i++) {
        this.ruleForm.idcLine = data[0].idcLine;
        this.fliter_region.push({
          idcId: data[i].idcId,
          idcNo: data[i].idcNo,
          region: `${data[i].datacenterNameShow}（${data[i].regionShow}）`, 
          // region: data[i].region
        });
      }
    },

    cancelForm () {
      this.$router.push({ path: '/worksheet/init' });
    },

    goBack () {
      this.$router.go(-1);
    },

    handleExceed () {
      this.$message.warning(this.$t('merge.uploadShouldBeOne'));
    },

    handleUploadChange (file) {
      // 去除文件名后缀
      // TODO 统一上传逻辑
      this.formData.fileName = file.name.replace(/\.[^.]*$/, '');
      console.log(this.formData.fileName, file.name);
    },

    beforeAvatarUpload (file) {
      this.formData.fileName = file.name;
      let isIMAGE = false;
      const name = file.name.substring(file.name.lastIndexOf('.') + 1);
      const arr = ['xls', 'xlsx'];
      if (arr.indexOf(name) > -1) {
        isIMAGE = true;
      }
      const isLt1M = file.size / 1024 / 1024 / 5 <= 1;
      if (!isIMAGE) {
        this.$message.error(this.$t('merge.uploadShouldBe'));
      }
      if (!isLt1M) {
        this.$message.error(this.$t('merge.uploadMax5M'));
      }
      return isIMAGE && isLt1M;
    }
  }
};
</script>
<style lang="scss">
@import "./scss/CabinetOutfit";
</style>



// WEBPACK FOOTER //
// src/components/workSheet/CabinetOutfit.vue